import { render, staticRenderFns } from "./replicarProduto.vue?vue&type=template&id=604a7add"
import script from "./replicarProduto.ts?vue&type=script&lang=js&external"
export * from "./replicarProduto.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604a7add')) {
      api.createRecord('604a7add', component.options)
    } else {
      api.reload('604a7add', component.options)
    }
    module.hot.accept("./replicarProduto.vue?vue&type=template&id=604a7add", function () {
      api.rerender('604a7add', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produto/replicarProduto.vue"
export default component.exports